import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { LogLevel, provideAuth } from 'angular-auth-oidc-client';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { provideStore } from '@ngrx/store';
import { documentReducer } from './store/documents/document.reducer';
import { DocumentEffects } from './store/documents/document.effects';
import { provideEffects } from '@ngrx/effects';
import { extractionRunReducer } from './store/extraction-run/extraction-run.reducer';
import { ExtractionRunEffects } from './store/extraction-run/extraction-run.effects';
import { ExtractionRuleEffects } from './store/extraction-rule/extraction-rule.effects';
import { extractionRuleReducer } from './store/extraction-rule/extraction-rule.reducer';
import { apiUrlKey } from './services/utils/api-resource.utils';
import { environment } from '../environments/environment';
import { authInterceptor } from './interceptors/auth.interceptor';
import { documentTypeReducer } from './store/document-type/document-type.reducer';
import { DocumentTypeEffects } from './store/document-type/document-type.effects';
import { HttpRequestInterceptor } from './services/interceptors/http/http.interceptor';
import { dataTypeReducer } from './store/data-type/data-type.reducer';
import { DataTypeEffects } from './store/data-type/data-type.effects';

export const HTTP_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpRequestInterceptor,
  multi: true,
};
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor]), withInterceptorsFromDi()),
    provideAuth({
      config: {
        authority: environment.auth.authority,
        redirectUrl: environment.auth.redirectUrl,
        postLogoutRedirectUri: environment.auth.postLogoutRedirectUri,
        clientId: environment.auth.clientId,
        scope: environment.auth.scope,
        responseType: environment.auth.responseType,
        silentRenew: environment.auth.silentRenew,
        silentRenewUrl: `${window.location.origin}/silent-renew.html`,
        useRefreshToken: environment.auth.useRefreshToken,
        maxIdTokenIatOffsetAllowedInSeconds: environment.auth.maxIdTokenIatOffsetAllowedInSeconds,
        customParamsAuthRequest: environment.auth.customParamsAuthRequest,
        customParamsRefreshTokenRequest: environment.auth.customParamsRefreshTokenRequest,
        customParamsEndSessionRequest: environment.auth.customParamsEndSessionRequest,
        customParamsCodeRequest: environment.auth.customParamsCodeRequest,
        disableIdTokenValidation: environment.auth.disableIdTokenValidation,
        ignoreNonceAfterRefresh: environment.auth.ignoreNonceAfterRefresh,
        allowUnsafeReuseRefreshToken: environment.auth.allowUnsafeReuseRefreshToken,
        autoUserInfo: environment.auth.autoUserInfo,
        renewTimeBeforeTokenExpiresInSeconds: environment.auth.renewTimeBeforeTokenExpiresInSeconds,
        secureRoutes: environment.auth.secureRoutes,
        logLevel: environment.auth.logLevel, // Enable debug logging
        historyCleanupOff: true,
        authWellknownEndpointUrl: environment.auth.wellKnownEndpointUrl,
      },
    }),
    importProvidersFrom(MatDialogModule, MatTabsModule),
    provideStore({
      documents: documentReducer,
      extractionRun: extractionRunReducer,
      extractionRule: extractionRuleReducer,
      documentTypes: documentTypeReducer,
      dataTypes: dataTypeReducer,
      extractionRules: extractionRuleReducer,
    }),
    provideEffects([
      DocumentEffects,
      ExtractionRunEffects,
      ExtractionRuleEffects,
      DocumentTypeEffects,
      DataTypeEffects,
      ExtractionRuleEffects,
    ]),
    { provide: apiUrlKey, useValue: environment.apiUrl },
    HTTP_INTERCEPTOR_PROVIDER,
  ],
};
